module.exports = __webpack_public_path__ + "img/85.9.TU.1161b069.png";